import { FC } from "react";
import { CardHeader, Drawer, useMediaQuery, Card, CardContent, Box, Button, Grid,
  FormControl, FormControlLabel, FormGroup, FormLabel, Typography, TextField, Tooltip, Divider} from "@mui/material";
import { useRecordContext } from "ra-core";
import { RoleResponseDto } from "~/gen/api/user";
import { RecPatch } from "~/dataProvider/tools";



export interface ViewDefaultRoleProps {
  open: boolean;
  onClose: () => void;
}

const ViewDefaultRole: FC<ViewDefaultRoleProps> = ({
  open,
  onClose
}) => {
  const match = useMediaQuery('(max-width: 530px)')
  const width = match ? 'calc(100vw - 50px)' : 480
  
  const record = useRecordContext<RoleResponseDto&RecPatch>()

  return (
    <Drawer
      anchor="right"
      // onOpen={() => {}}
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          p: 2,
          width: width,
        }
      }}
    >
      <Card>
        <CardHeader title={"Role Detail"} />
        <CardContent>
          <Grid container spacing={4} >
            <Grid item xs={12} >
              <Typography variant="subtitle2">{record?.name}</Typography>
            </Grid>
            <Grid item xs={12} >
              <TextField multiline label="Description" name="description" fullWidth disabled={true} value={record?.description ?? ""} maxRows={2} />
            </Grid>
            <Grid item xs={12}>
              <FormControl sx={{ ml: 3, width: 'calc(100% - 18px)' }} component="fieldset" variant="standard">
                <FormLabel component="legend" sx={{ mb: 1 }}>Assigned permissions</FormLabel>
                <Box sx={{ overflowY: 'auto', maxHeight: 'calc(100vh - 380px)' }}>
                  <FormGroup sx={{ '& label': { my: 1, ml: 2 } }} >
                    {(record?.permissions ?? []).sort((a, b) => (a.name ?? '') < (b.name ?? '') ? -1 : 1).map(p =>
                      <Tooltip title={p.description ?? ''} key={p.id}>
                        <FormControlLabel
                          control={<span/>}
                          key={p.id || -1}
                          label={p.name || ''}
                        />
                      </Tooltip>
                    )}
                  </FormGroup>
                </Box>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            p: 2
          }}
        >
          <Button
            color="primary"
            onClick={onClose}
            variant="outlined"
          >
            Cancel
          </Button>
        </Box>
      </Card>
    </Drawer>

  )
}


export default ViewDefaultRole;
